import styled, { css } from 'styled-components';
import theme from '../../assets/styles/theme';

export const Toggle = styled.div`
  display: flex;
  position: relative;
  align-items: center;
`;

export const ToggleWrapper = styled.label`
  position: relative;
  display: flex;
  align-items: center;
  ${theme.textStyles['text-preset-9']()}
  ${({ disabled }) =>
    disabled &&
    `
    color: ${theme.colors.neutral.text.regular};
  `}
`;

export const ToggleCheckbox = styled.input.attrs(() => ({ type: 'checkbox' }))`
  opacity: ${theme.opacities['opacity-4']};
`;

export const ToggleSwitch = styled.span`
  position: relative;
  display: inline-block;
  min-width: 42px;
  height: 24px;
  margin-left: ${theme.spacing['spacing-3']};
  ${({ size }) => getToggleSize(size)};
`;

export const Switch = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: ${theme.borderRadius['border-radius-5']};
  box-shadow: inset 0 0 0 1px ${theme.colors['neutral'].border.weak};
  background: ${theme.colors.neutral.bg.regular};

  &:before {
    position: absolute;
    content: '';
    background-color: ${theme.colors.neutral.bg.stronger};
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: ${theme.borderRadius['border-radius-5']};
    ${({ size }) => getSpanSize(size)}
  }

  ${ToggleCheckbox}:hover:not(:disabled) + & {
    box-shadow: inset 0 0 0 1px ${theme.colors['neutral'].border.regular};
  }

  ${ToggleCheckbox}:disabled + & {
    background: ${theme.colors.neutral.bg.strong};
  }
  ${ToggleCheckbox}:checked + & {
    background: ${theme.colors['secondary-1'].bg.regular};
  }

  ${ToggleCheckbox}:checked:disabled + & {
    background: ${theme.colors.neutral.bg.strong};
  }

  ${ToggleCheckbox}:checked + &:before {
    ${({ size }) => getSpanTransform(size)}
    background-color: ${theme.colors.neutral.bg.weak};
  }
  ${ToggleCheckbox}:checked:hover:not(:disabled) + & {
    background-color: ${theme.colors['secondary-1'].bg.strong};
  }

  ${ToggleCheckbox}:disabled + &:before {
    background-color: ${theme.colors.neutral.bg.regular};
  }

  ${ToggleCheckbox}:checked:disabled + &:before {
    background-color: ${theme.colors.neutral.bg.regular};
  }
`;

const getToggleSize = (size) => {
  switch (size) {
    case 'sm':
      return css`
        width: 42px;
        height: 24px;
      `;
    case 'md':
      return css`
        width: 60px;
        height: 34px;
      `;
  }
};

const getSpanSize = (size) => {
  switch (size) {
    case 'sm':
      return css`
        height: 20px;
        width: 20px;
        left: ${theme.spacing['spacing-1']};
        bottom: ${theme.spacing['spacing-1']};
      `;
    case 'md':
      return css`
        height: 26px;
        width: 26px;
        left: ${theme.spacing['spacing-2']};
        bottom: ${theme.spacing['spacing-2']};
      `;
  }
};

const getSpanTransform = (size) => {
  switch (size) {
    case 'sm':
      return css`
        -webkit-transform: translateX(18px);
        -ms-transform: translateX(18px);
        transform: translateX(18px);
      `;
    case 'md':
      return css`
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
      `;
  }
};
